import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function Reveal({
  children,
  className = '',
  delay = 0
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.15
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-181" data-mp="3bixg6jfdsfs2">
      {children}
    </motion.div>;
}